module.exports = __webpack_public_path__ + "media/images/common/menu_outer_ov-aaf629fbddfa3b7c5bcf730ca0e900de.gif";